import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "text-center" }
const _hoisted_2 = { class: "text-center" }
const _hoisted_3 = { class: "text-center" }
const _hoisted_4 = {
  key: 0,
  class: "text-center"
}
const _hoisted_5 = {
  key: 1,
  class: "text-center"
}
const _hoisted_6 = {
  key: 2,
  class: "text-center"
}
const _hoisted_7 = {
  key: 3,
  class: "text-center"
}
const _hoisted_8 = {
  key: 4,
  class: "text-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UploadDocuments = _resolveComponent("UploadDocuments")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_ColumnCorrespondence = _resolveComponent("ColumnCorrespondence")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { flat: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_window, {
        modelValue: _ctx.step,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.step) = $event)),
        touchless: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_window_item, { value: 0 }, {
            default: _withCtx(() => [
              _createVNode(_component_UploadDocuments, {
                showFirstPrevious: false,
                documentType: 'COMPANIES',
                inExtensions: ['csv', 'tsv', 'txt', 'xlsx', 'xls'],
                multiple: false,
                freeTag: false,
                gDrive: false,
                dBox: false,
                onFileInput: _ctx.onFileChanged,
                onFileDeleted: _ctx.onFileDeleted,
                onTestFileInput: _ctx.onTestFileChanged
              }, null, 8, ["onFileInput", "onFileDeleted", "onTestFileInput"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_window_item, {
            value: 1,
            style: {"max-width":"1000px"}
          }, {
            default: _withCtx(() => [
              (_ctx.step > 0 && _ctx.existingFile)
                ? (_openBlock(), _createBlock(_component_ColumnCorrespondence, {
                    key: 0,
                    ref: "columnComponent",
                    result: _ctx.result,
                    extension: _ctx.extension,
                    actions: _ctx.actions,
                    ruleManager: _ctx.ruleManager,
                    formatColumns: _ctx.formatColumns,
                    onColumnsChosen: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onChosenColumns($event))),
                    onBack: _cache[1] || (_cache[1] = ($event: any) => (_ctx.step = 0))
                  }, null, 8, ["result", "extension", "actions", "ruleManager", "formatColumns"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_v_window_item, { value: 2 }, {
            default: _withCtx(() => [
              _createVNode(_component_v_data_table, {
                headers: _ctx.importedHeaders,
                items: _ctx.importedItems,
                class: "table",
                density: "compact",
                "fixed-header": "",
                loading: _ctx.verifLoading
              }, {
                item: _withCtx((props) => [
                  _createElementVNode("tr", {
                    style: _normalizeStyle(
                                'background-color:' +
                                props.item.colorAlert +
                                '; pointer-events: none;'
                            )
                  }, [
                    _createElementVNode("td", _hoisted_1, _toDisplayString(props.item.name), 1),
                    _createElementVNode("td", _hoisted_2, _toDisplayString(_ctx.getSiretValue(props.item.siret) || ""), 1),
                    _createElementVNode("td", _hoisted_3, _toDisplayString(props.item.address), 1),
                    (
                                    props.item.status === 'NEW_THIRDPARTY_COMPANY' ||
                                    props.item.status === 'NEW_CLIENT'
                                )
                      ? (_openBlock(), _createElementBlock("td", _hoisted_4, [
                          _createVNode(_component_v_icon, {
                            icon: "$fa-check",
                            color: "green"
                          })
                        ]))
                      : (
                                    props.item.status === 'EXISTING_THIRDPARTY_COMPANY' ||
                                    props.item.status === 'EXISTING_CLIENT'
                                )
                        ? (_openBlock(), _createElementBlock("td", _hoisted_5, " La société existe déjà "))
                        : (props.item.status === 'EXISTING_COMPANY')
                          ? (_openBlock(), _createElementBlock("td", _hoisted_6, [
                              _createVNode(_component_v_icon, {
                                icon: "$fa-check",
                                color: "green"
                              })
                            ]))
                          : (props.item.status === 'SIRET_WRONG')
                            ? (_openBlock(), _createElementBlock("td", _hoisted_7, " Le siret n'est pas valable "))
                            : (_openBlock(), _createElementBlock("td", _hoisted_8, [
                                _createVNode(_component_v_progress_circular, {
                                  indeterminate: "",
                                  color: "primary"
                                })
                              ]))
                  ], 4)
                ]),
                _: 1
              }, 8, ["headers", "items", "loading"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}